import React from 'react';
import map from '../../images/map.png'

const GoogleMap = () => {
    return (
        <div>
            <img src={map} alt=""/>
        </div>
    );
};

export default GoogleMap;